import { createFeature, createReducer, on } from "@ngrx/store";
import { ResultStoreInterface } from "../../interfaces";
import { resultActions } from "./result.action";
const initailState: ResultStoreInterface = {
    resultsCache: {},
    result: null,
    previewData: null,
    uploadUrlData: null,
};

const resultFeature = createFeature({
    name: "result",
    reducer: createReducer(
        initailState,
        on(resultActions.setResult, (state, action) => {
            return {
                ...state,
                resultsCache: {
                    ...state.resultsCache,
                    [action.data.id]: action.data,
                },
                result: action.data,
            };
        }),
        on(resultActions.setResultPreview, (state, action) => {
            return {
                ...state,
                previewData: action.data,
            };
        }),
        on(resultActions.setUploadUrlData, (state, action) => {
            return {
                ...state,
                uploadUrlData: action.data,
            };
        }),
        on(resultActions.clearData, (state, action) => {
            return { ...initailState };
        }),
    ),
});

export const {
    name: resultFeatureKey,
    reducer: resultReducer,
    selectResult,
    selectResultsCache,
    selectPreviewData,
    selectUploadUrlData,
} = resultFeature;
